export default "__VITE_ASSET__J3gymA0I__";